import Tone from 'tone';

export const exportToWAV = (buffer, sampleRate=Tone.Master.context.sampleRate, useArrayBuffer=false) => {
    return new Promise((resolve, reject) => {
        
        var fd = new FormData();
        var self = this;
        
        // start a new worker 
        // we can't use Recorder directly, since it doesn't support what we're trying to do
        var worker = new Worker(window.isNFT ? 'recorderWorker.js' : '/recorderWorker.js');
        
        // initialize the new worker
        worker.postMessage({
            command: 'init',
            config: {sampleRate: sampleRate,
                     numChannels: buffer.length}
        });
        
        
        // callback for `exportWAV`
        worker.onmessage = function( e ) {
            var blob = e.data;
            var arrayBuffer;
            var fileReader = new FileReader();
            fileReader.onload = function() {
                arrayBuffer = this.result;
                resolve(useArrayBuffer ? arrayBuffer : new Buffer(arrayBuffer));
            };
            fileReader.readAsArrayBuffer(blob);
        };
        
        // send the channel data from our buffer to the worker
        worker.postMessage({
            command: 'record',
            buffer: buffer
        });
        
        // ask the worker for a WAV
        worker.postMessage({
            command: 'exportWAV',
            type: 'audio/wav'
        });
        
    });
}

